import { render, staticRenderFns } from "./IconDdwk.vue?vue&type=template&id=c8a29064"
import script from "./IconDdwk.vue?vue&type=script&lang=js"
export * from "./IconDdwk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports